import { render, staticRenderFns } from "./HowTo.vue?vue&type=template&id=475d8c14&scoped=true&"
import script from "./HowTo.vue?vue&type=script&lang=js&"
export * from "./HowTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475d8c14",
  null
  
)

export default component.exports